"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2361],{

/***/ 49020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ EmptyState; }
});

// EXTERNAL MODULE: ../../.yarn/cache/tslib-npm-2.3.1-0e21e18015-de17a98d46.zip/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(91806);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/i18n.es.js
var i18n_es = __webpack_require__(8756);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(95889);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/mobile/EmptyState/search-no-result.es.js
var emptyImage = "https://shopfront-cdn.tekoapis.com/static/e536f0592aa3c8b1.png";



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/mobile/Flex/Flex.es.js
var Flex_es = __webpack_require__(3061);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/mobile/Text/Text.es.js
var Text_es = __webpack_require__(27893);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/mobile/EmptyState/EmptyState.es.js








const EmptyState = (_a) => {
    var { text } = _a, props = (0,tslib_es6/* __rest */._T)(_a, ["text"]);
    return (react.createElement(Flex_es/* Flex */.k, Object.assign({}, props, { flexDirection: "column", justifyContent: "center", alignItems: "center" }),
        react.createElement(LazyImage_es/* LazyImage */.w, { height: 128, width: 128, src: emptyImage }),
        react.createElement(Text_es/* Text */.x, { fontSize: 12, color: "#848788", marginTop: "24px", paddingX: "2rem" }, text || (0,i18n_es.t)('Không tìm thấy dữ liệu'))));
};




/***/ }),

/***/ 3061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ Flex; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97204);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79690);





const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, (props) => `
  display: flex;
  ${props.justifyContent ? `justify-content: ${props.justifyContent};` : ''}
  ${props.alignItems ? `align-items: ${props.alignItems};` : ''}
  ${props.flexDirection ? `flex-direction: ${props.flexDirection};` : ''}
`);
const Flex = (_a) => {
    var { children, onClick } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["children", "onClick"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, Object.assign({ onClick: () => {
            if (onClick)
                onClick();
        } }, props), children));
};




/***/ }),

/***/ 92361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MiniNotification": function() { return /* binding */ MiniNotification; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17963);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97204);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75068);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91590);
/* harmony import */ var _teko_ecommerce_mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49020);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11686);
/* harmony import */ var _desktop_organisms_MiniNotificationItem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88639);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63466);








function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);\n  width: 384px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 1rem;\n  color: #a7abc3;\n  text-decoration: none;\n  &:hover {\n    color: #82869e;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 1rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 24px;\n  color: #82869e;\n  padding: 10px 16px;\n  background-color: #f8f8fc;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .styled.div */ .z.div(_templateObject());
var StyledButton = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z)(_templateObject1());
var EmptyWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .styled.div */ .z.div(_templateObject2());
var Title = _teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .styled.div */ .z.div(_templateObject3());
var MiniNotification = function(param) {
    var onHide = param.onHide;
    var ref = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useNotification */ .lm)(), notifications = ref.notifications, promotions = ref.promotions, handleNotificationClicked = ref.handleNotificationClicked, loading = ref.loading, status = ref.status;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    if (status === contexts__WEBPACK_IMPORTED_MODULE_5__/* .PageStatus.EMPTY */ .ti.EMPTY && !loading) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EmptyWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce_mobile__WEBPACK_IMPORTED_MODULE_6__/* .EmptyState */ .u, {
                    text: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)('Bạn chưa c\xf3 th\xf4ng b\xe1o mới')
                })
            })
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    !!promotions.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)('KHUYẾN M\xc3I')
                            }),
                            promotions.slice(0, 3).map(function(promotion) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_desktop_organisms_MiniNotificationItem__WEBPACK_IMPORTED_MODULE_8__/* .MiniNotificationItem */ .f, {
                                    title: promotion.label,
                                    message: promotion.subLabel,
                                    isRead: true,
                                    onClick: function() {
                                        if (promotion.url) {
                                            onHide && onHide();
                                            router.push(promotion.url);
                                        }
                                    },
                                    avatar: promotion.imageUrl
                                }, promotion.id);
                            })
                        ]
                    }),
                    !!notifications.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)('ĐƠN H\xc0NG')
                            }),
                            notifications.slice(0, 3).map(function(notification) {
                                if (notification) {
                                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_desktop_organisms_MiniNotificationItem__WEBPACK_IMPORTED_MODULE_8__/* .MiniNotificationItem */ .f, {
                                        title: notification.title,
                                        message: notification.message,
                                        isRead: notification.is_read,
                                        onClick: function() {
                                            onHide && onHide();
                                            handleNotificationClicked(notification);
                                            if (notification.deepLink) {
                                                router.push(notification.deepLink);
                                            } else if (notification.order) {
                                                router.push({
                                                    pathname: "/account/orders/[orderId]",
                                                    query: {
                                                        orderId: notification.order.orderId
                                                    }
                                                }, {
                                                    pathname: "/account/orders/".concat(notification.order.orderId)
                                                });
                                            }
                                        },
                                        time: notification.created_at,
                                        avatar: !notification.order ? notification.image_url : notification.order.imageUrl
                                    }, notification.id));
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_9__["default"], {
                href: "/notification",
                as: "/notification",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                    link: true,
                    block: true,
                    tag: "a",
                    onClick: onHide,
                    "data-track-content": true,
                    "data-content-region-name": "MiniNotification",
                    "data-content-name": "viewNotificationFromMiniNotification",
                    "data-content-target": "Notification",
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)('Xem tất cả th\xf4ng b\xe1o')
                })
            })
        ]
    }));
};


/***/ }),

/***/ 88639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ MiniNotificationItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59802);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95889);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51748);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  margin-right: 16px;\n  width: 64px;\n  height: 64px;\n  border: 1px solid #e0e0e0;\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: unset;\n  border-radius: 50%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: calc(100% - 80px);\n  .message {\n    font-size: 14px;\n    color: #848788;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    line-height: 18px;\n    margin-top: 4px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 24px;\n  color: #434657;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  margin-right: 8px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n  color: #82869e;\n  line-height: 16px;\n  min-width: fit-content;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 13px;\n  color: #82869e;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  line-height: 20px;\n  margin-top: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
var Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(function(param) {
    var isRead = param.isRead;
    return "\n  padding: 16px;\n  display: flex;\n  cursor: pointer;\n  border-bottom: 1px solid #e0e0e0;\n  background-color: ".concat(isRead ? 'white' : 'rgb(255, 242, 242)', ";\n");
});
var Avatar = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject());
var ProductImageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject1());
var ContentWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject2());
var HeaderWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject3());
var TitleWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span */ .Z.span(_templateObject4());
var TimeWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span */ .Z.span(_templateObject5());
var MessageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span */ .Z.span(_templateObject6());
var MiniNotificationItem = function(props) {
    var date = new Date(props.time);
    var formatDate = "".concat(date.getDate(), "/").concat(date.getMonth() + 1, " - ").concat(date.getHours(), ":").concat(date.getMinutes());
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, _objectSpread({
        isRead: props.isRead
    }, props, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Avatar, {
                children: !!props.avatar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductImageWrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .LazyImage */ .w, {
                        src: props.avatar,
                        alt: "",
                        borderRadius: 50,
                        contain: true
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(HeaderWrapper, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TitleWrapper, {
                                children: props.title
                            }),
                            props.time && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TimeWrapper, {
                                children: formatDate
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MessageWrapper, {
                        dangerouslySetInnerHTML: {
                            __html: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_2__/* .htmlDecode */ .l_)(props.message)
                        }
                    })
                ]
            })
        ]
    })));
};


/***/ })

}]);